import * as yup from 'yup';

export const ConsentsSchema = yup.object().shape({
  consents: yup.array().of(
    yup
      .object()
      .shape({
        id: yup.string().required(),
        consented: yup.boolean().required('For å fortsette, ber vi deg ta et valg her.'),
        undetermined: yup
          .boolean()
          .oneOf([false], 'For å fortsette, ber vi deg ta et valg her.')
          .required('For å fortsette, ber vi deg ta et valg her.'),
      })
      .typeError('For å fortsette, ber vi deg ta et valg her.'),
  ),
});
